import CustomForm from "../../form/CustomForm";

const CustomFormSkeleton = ({
    className = "grid grid-cols-1 md:grid-cols-2 gap-3",
    showInputs = 4,
    showTextarea = true,
    showCheckbox = true,
}) => {
    // Generate mock form config for skeleton
    const mockFormConfig = {};

    // Add mock input fields
    for (let i = 0; i < showInputs; i++) {
        mockFormConfig[`mockInput${i + 1}`] = {
            condition: true,
            type: "text",
            label: "Cargando...",
            name: `mockInput${i + 1}`,
            disabled: true,
        };
    }

    // Add mock textarea if requested
    if (showTextarea) {
        mockFormConfig.mockTextarea = {
            condition: true,
            type: "textarea",
            label: "Cargando...",
            name: "mockTextarea",
            disabled: true,
        };
    }

    // Add mock checkbox if requested
    if (showCheckbox) {
        mockFormConfig.mockCheckbox = {
            condition: true,
            type: "checkbox",
            label: "Cargando...",
            name: "mockCheckbox",
            disabled: true,
        };
    }

    return (
        <CustomForm
            formConfig={mockFormConfig}
            errors={{}}
            register={() => {}}
            className={className}
            isLoading={true}
        />
    );
};

export default CustomFormSkeleton;
